import React from "react";
import { JOURNEY, STATUS_LABELS } from "./StatusBadge";
import { Check } from "lucide-react";

export default function ProgressStepper({ currentStatus }) {
  const branchStatuses = ["QUALITY_FAILED", "REWORK", "REJECTED_SCRAPPED", "ON_HOLD", "CANCELLED"];
  const isBranch = branchStatuses.includes(currentStatus);

  // Determine active index. For branch statuses, mark the QUALITY_PENDING point as active reference.
  let activeIdx;
  if (isBranch) {
    activeIdx = JOURNEY.indexOf("QUALITY_PENDING");
  } else {
    activeIdx = JOURNEY.indexOf(currentStatus);
  }

  return (
    <div data-testid="progress-stepper" className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center min-w-max py-2">
        {JOURNEY.map((s, i) => {
          const done = i < activeIdx;
          const active = i === activeIdx && !isBranch;
          const pending = i > activeIdx;
          return (
            <React.Fragment key={s}>
              <div className="flex flex-col items-center px-3 min-w-[90px]">
                <div
                  className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-xs font-semibold font-mono ${
                    done
                      ? "bg-emerald-500 border-emerald-500 text-white"
                      : active
                      ? "bg-blue-900 border-blue-900 text-white"
                      : "bg-white border-slate-300 text-slate-400"
                  }`}
                >
                  {done ? <Check className="w-4 h-4" strokeWidth={3} /> : i + 1}
                </div>
                <div
                  className={`mt-2 text-[10px] uppercase tracking-wide text-center leading-tight ${
                    active
                      ? "text-blue-900 font-semibold"
                      : done
                      ? "text-emerald-700 font-medium"
                      : "text-slate-400"
                  }`}
                >
                  {STATUS_LABELS[s]}
                </div>
              </div>
              {i < JOURNEY.length - 1 && (
                <div
                  className={`h-[2px] flex-1 min-w-[32px] mt-[-22px] ${
                    i < activeIdx ? "bg-emerald-500" : "bg-slate-200"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {isBranch && (
        <div className="mt-2 flex justify-center">
          <div className="inline-flex items-center gap-2 text-xs text-red-700 bg-red-50 border border-red-200 px-3 py-1 rounded">
            <span className="w-1.5 h-1.5 rounded-full bg-red-600" />
            Diverted to <strong>{STATUS_LABELS[currentStatus]}</strong>
          </div>
        </div>
      )}
    </div>
  );
}
